/* ============================================================
   Новости: чипы категорий + сетка карточек.
   ============================================================ */
import { useFedStore, useL } from '../store';
import { useFedContent, isPublished, uploadUrl } from '../content';
import { cover } from '../data';
import { Rv, PageHead } from '../ui';

export default function FedNews() {
  const { go, lang, newsCat, setNewsCat } = useFedStore();
  const L = useL();
  // черновики из админки в списки витрины не попадают
  const news = useFedContent((s) => s.news).filter(isPublished);

  const cats = ['all'].concat(Array.from(new Set(news.map((n) => n.cat_ru))));
  const list = news.filter((n) => newsCat === 'all' || n.cat_ru === newsCat);

  return (
    <div className="fed-pagewrap max-w-[1320px] mx-auto" style={{ padding: '52px 24px 72px' }}>
      <PageHead eyebrow={L.newsEyebrow} title={L.news_h1} sub={L.news_sub} />

      <Rv className="flex gap-2 flex-wrap" style={{ marginBottom: 26 }}>
        {cats.map((c) => {
          const on = newsCat === c;
          return (
            <button
              key={c}
              onClick={() => setNewsCat(c)}
              className="h-[38px] px-[18px] rounded-full cursor-pointer font-body font-semibold"
              style={{
                fontSize: 13.5,
                border: `1px solid ${on ? 'var(--fed-accent)' : 'var(--fed-line-2)'}`,
                background: on ? 'var(--fed-accent)' : 'var(--fed-surface-2)',
                color: on ? '#fff' : 'var(--fed-fg-soft)',
              }}
            >
              {c === 'all' ? L.catAll : c}
            </button>
          );
        })}
      </Rv>

      <div className="grid gap-[18px]" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(320px,1fr))' }}>
        {list.map((n, i) => (
          <Rv
            key={n.id}
            delay={(i % 3) * 0.07}
            onClick={() => go('article', { articleId: n.id })}
            className="fed-hover-lift flex flex-col overflow-hidden rounded-2xl bg-surface border border-line cursor-pointer"
          >
            <div className="relative overflow-hidden" style={{ height: 170, background: cover(n.hue) }}>
              {n.cover && <img src={uploadUrl(n.cover)} alt="" className="absolute inset-0 w-full h-full" style={{ objectFit: 'cover' }} />}
              {!n.cover && <div className="fed-grid-tex" />}
              <span className="absolute font-mono uppercase text-gold rounded-md" style={{ top: 12, left: 12, padding: '5px 10px', fontSize: 10, letterSpacing: '.1em', background: 'rgba(6,6,8,.7)', backdropFilter: 'blur(6px)' }}>
                {n['cat_' + lang]}
              </span>
            </div>
            <div className="p-5 flex flex-col flex-1">
              <div className="font-mono text-fg-faint" style={{ fontSize: 11, marginBottom: 9 }}>{n.date}</div>
              <h3 className="font-body font-extrabold text-fg" style={{ fontSize: 18, lineHeight: 1.3, textTransform: 'none', letterSpacing: 0 }}>{n['title_' + lang]}</h3>
              <p className="text-fg-muted flex-1" style={{ fontSize: 13.5, lineHeight: 1.6, marginTop: 10 }}>{n['ex_' + lang]}</p>
              <span className="font-display font-semibold uppercase text-accent-bright" style={{ marginTop: 14, fontSize: 13, letterSpacing: '.04em' }}>
                {L.readMore} →
              </span>
            </div>
          </Rv>
        ))}
      </div>
    </div>
  );
}
